import { ComponentsTypes } from '@/constants/componentsTypes';
import { LinkTypes } from '@/constants/linkTypes';
import { RichText as RichTextType } from '@/schemas/sceneDataSchema';
import { Typography } from '@mui/material';
import { HrefLink } from './formElements/typographies/HrefLink';
import { NavigationLink } from './formElements/typographies/NavigationLink';
import { RouteFn } from '@/hooks/use-flow';
import { TypographyInline } from './formElements/typographies/Typography';
import { ModalLink } from './formElements/typographies/ModalLink';
import { CookieManagementLink } from './formElements/typographies/CookieManagementLink';

interface RichTextProps {
  component: RichTextType;
  route: RouteFn;
}

export const RichText: React.FC<RichTextProps> = ({ component, route }) => {
  return (
    <Typography
      align={component.align}
      variant={component.variant}
    >
      {component.spans.map((span, index) => {
        const spanWithVariant = component.variant ? { ...span, variant: component.variant } : span;

        switch (spanWithVariant.type) {
          case ComponentsTypes.TYPOGRAPHY:
            return (
              <TypographyInline
                key={index}
                component={spanWithVariant}
              />
            );
          case LinkTypes.COOKIE_MANAGEMENT_LINK:
            return (
              <CookieManagementLink
                key={index}
                component={spanWithVariant}
              />
            );
          case LinkTypes.HREF:
            return (
              <HrefLink
                key={index}
                component={spanWithVariant}
              />
            );
          case LinkTypes.NAVIGATION:
            return (
              <NavigationLink
                key={index}
                component={spanWithVariant}
                route={route}
              />
            );
          case LinkTypes.MODAL:
            return (
              <ModalLink
                key={index}
                component={spanWithVariant}
              />
            );
          default:
            throw new Error('unknown rich text child');
        }
      })}
    </Typography>
  );
};
